import { useTranslation } from 'react-i18next'
import { Link } from '@tanstack/react-router'
import { UtensilsCrossed, Users, UserCircle, ChevronRight } from 'lucide-react'

const sections = [
  {
    key: 'cooking',
    links: [
      { to: '/templates', icon: UtensilsCrossed, label: 'links.templates' },
    ],
  },
  {
    key: 'settings',
    links: [
      { to: '/household', icon: Users, label: 'links.household' },
      { to: '/account', icon: UserCircle, label: 'links.account' },
    ],
  },
] as const

export function MoreView() {
  const { t } = useTranslation('more')

  return (
    <div className="px-4 pt-4 pb-24">
      <h1 className="text-xl font-bold text-ink mb-4">{t('title')}</h1>
      {sections.map((section) => (
        <div key={section.key} className="mb-6">
          <h2 className="text-sm font-medium text-muted uppercase tracking-wide mb-1 px-4">
            {t(`sections.${section.key}`)}
          </h2>
          <div>
            {section.links.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="py-3 px-4 border-b border-line flex items-center gap-3 focus-visible:ring-2 focus-visible:ring-accent focus-visible:outline-none"
              >
                <link.icon className="w-5 h-5 text-ink" />
                <span className="flex-1 text-ink">{t(link.label)}</span>
                <ChevronRight className="w-4 h-4 text-muted" />
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
